<template>
  <div class="add-funds-cash">
    <fee-waived-banner
      level="success"
      :text="promoCodeDetail.friendlyDescription"
      v-if="showPromoNotification && false"
    >
    </fee-waived-banner>
    <fee-waived-banner
      :level="instantCreditBoxLevel"
      :text="instantCreditBoxMessage"
      v-if="showInstantCreditNotification && false"
    >
    </fee-waived-banner>
    <div v-if="depositWarning" v-html="depositWarning" class="predictit-embedded-alert"></div>
    <div class="add-funds-cash__logo">
      <img v-asset-cdn-src="`/static/img/paynearme.18d924a.jpg`" />
    </div>
    <div class="add-funds-cash__button" v-if="url">
      <button
        :disabled="buttonDisabled"
        class="button button--large button--primary button--full-width"
        @click="onDeposit"
      >
        Deposit
      </button>
    </div>
    <p class="add-funds-cash__error" v-if="error">
      {{ error }}
    </p>
    <template v-if="url">
      <p class="add-funds-cash__note">
        After clicking on the Deposit button above, you will be taken to a third-party site to
        complete your transaction.
      </p>
      <deposit-disclaimer :disclaimer="disclaimer"></deposit-disclaimer>
    </template>
  </div>
</template>

<script src="./add-funds-cash.js"></script>
<style src="./add-funds-cash.scss" lang="scss"></style>
